// frontend/src/components/RedirectIfAuthenticated.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Componente para redireccionar a la página principal si el usuario ya está autenticado
 * Permite el acceso a la ruta solamente si el usuario NO está autenticado
 */
const NewRedirectIfAuthenticated = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();

    // Mientras se verifica la autenticación, mostrar un indicador de carga
    if (loading) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
            </div>
        );
    }

    // Si está autenticado, redirigir a la página principal
    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    // Si no está autenticado, mostrar el contenido (login o registro)
    return children;
};

export default NewRedirectIfAuthenticated;